import React, { useState } from 'react';

import { useSnrwbCore } from '../../../../common/hooks/useSnrwbCore';
import { Filter, FilterReportData } from '../../../components/Reports/Filter';
import { ReportJudgmentsCountType } from '../../../../common/types/ReportTypes';
import { ReportJudgmentsKind } from '../../../components/ReportJudgment/ReportJudgmentsKind';

export const ReportJudgmentsKindView: React.FC = () => {
  const snrwbApi = useSnrwbCore();
  const [filterApplied, setFilterApplied] = useState(false);
  const [usedFilter, setUsedFilter] = useState<FilterReportData | undefined>(
    {},
  );
  const [data, setData] = useState<ReportJudgmentsCountType>({
    details: {},
    sum: {},
  });

  const onSearch = (filter?: FilterReportData) => {
    setFilterApplied(true);
    setUsedFilter(filter);
    snrwbApi.reports
      .reportJudgmentsInProceedingAndPak(false, filter)
      .then(dataReports => {
        setData(dataReports);
      });
  };

  return (
    <>
      <Filter
        onSearch={onSearch}
        reportName="Wydane orzeczenia w postępowaniach administracyjnych wszczętych na podstawie uowb"
      />
      <ReportJudgmentsKind
        data={data}
        reportName="Wydane orzeczenia w postępowaniach administracyjnych wszczętych na podstawie uowb"
        filterApplied={filterApplied}
        usedFilter={usedFilter}
      />
    </>
  );
};
